module.exports = __webpack_public_path__ + "static/media/time-zone.56c985b1.svg";